// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout-module--page--16DWN","fullHeight":"Layout-module--fullHeight--2zDMJ","main":"Layout-module--main--3jeRe"};